import React from 'react';
import { Tag, Size, ArtistOption } from '../../types';
import './GalleryFilters.css';

interface GalleryFiltersProps {
  tags: Tag[];
  availableSizes: Size[];
  artists: ArtistOption[];
  selectedTags: number[];
  selectedSize: string;
  selectedArtist: string;
  onTagToggle: (tagId: number) => void;
  onSizeChange: (value: string) => void;
  onArtistChange: (value: string) => void;
}

const GalleryFilters: React.FC<GalleryFiltersProps> = ({
  tags,
  availableSizes,
  artists,
  selectedTags,
  selectedSize,
  selectedArtist,
  onTagToggle,
  onSizeChange,
  onArtistChange
}) => {
  return (
    <div className="gallery-filters-horizontal">
      <div className="filters-row">
        <div className="filter-item">
          <label className="filter-label">Tags</label>
          <div className="tags-list-horizontal">
            {tags.length > 0 ? (
              tags.map((tag) => (
                <button
                  key={tag.id}
                  className={`tag-button ${selectedTags.includes(tag.id) ? 'active' : ''}`}
                  onClick={() => onTagToggle(tag.id)}
                >
                  {tag.name}
                </button>
              ))
            ) : (
              <span className="no-tags">No tags available</span>
            )}
          </div>
        </div>

        <div className="filter-item">
          <label className="filter-label">Size</label>
          <select
            value={selectedSize}
            onChange={(e) => onSizeChange(e.target.value)}
            className="filter-select"
          >
            <option value="">All Sizes</option>
            {availableSizes.map(size => (
              <option key={size.id} value={size.name}>{size.name}</option>
            ))}
          </select>
        </div>

        <div className="filter-item">
          <label className="filter-label">Artist</label>
          <select
            value={selectedArtist}
            onChange={(e) => onArtistChange(e.target.value)}
            className="filter-select"
          >
            <option value="">All Artists</option>
            {artists.map((artist, index) => {
              const name = artist.artistName || 'Unknown Artist';
              const value = artist.artistId ? `id:${artist.artistId}` : `name:${name}`;
              return (
                <option key={`${value}-${index}`} value={value}>
                  {name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
};

export default GalleryFilters;
